import React from 'react';
import PropTypes from 'prop-types';

import AddField from './add';
import Field from './field';

import './styles.scss';

export default function PlaybookFields({ playbook, stage }) {
  return (
    <div className="playbook-fields">
      <p>Capture the following <b>data fields:</b></p>

      <div className="table-container mb-3">
        <table className="table align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Required</th>
              <th>Property Types</th>
              <th style={{ width: 0 }} />
            </tr>
          </thead>

          <tbody>
            {playbook.fieldsByStage[stage.key].map(field => (
              <Field field={field} key={field.id} playbook={playbook} />
            ))}
          </tbody>
        </table>
      </div>

      <AddField playbook={playbook} stage={stage.key} />
    </div>
  );
}

PlaybookFields.propTypes = {
  playbook: PropTypes.shape({
    fieldsByStage: PropTypes.object.isRequired,
  }).isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
};
